import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=7f1dffa2&"
import script from "./baseTable.vue?vue&type=script&lang=js&"
export * from "./baseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports